const online_learing = `Nykymaailmassa opiskelijoilla on erilaisia vaihtoehtoja oppimiseen.
Jotkut oppilaat opiskelevat kotoa tietokoneen avulla, kun taas toiset käyvät koulua kuten aina.
Kotoa opiskelu antaa sinulle vapauden valita milloin ja missä haluat opiskella.
Voit löytää paljon mielenkiintoista luettavaa ja katsottavaa tietokoneella.
Voi kuitenkin olla vaikeaa pysyä keskittyneenä ilman, että lähellä on opettaja, ja saatat jäädä puhumatta ystävien kanssa henkilökohtaisesti.
Toisaalta kouluun käyminen tarkoittaa, että saat puhua opettajien ja ystävien kanssa kasvokkain.
Voit oppia ja leikkiä yhdessä, mikä on hauskaa.
Mutta jokapäiväinen koulunkäynti voi olla väsyttävää, ja joskus sinne on vaikea päästä, varsinkin jos asut kaukana.
Jokaisella oppimistavalla on omat hyvät ja ei niin hyvät puolensa.
Jotkut ihmiset saattavat mieluummin opiskella kotoa, kun taas toiset nauttivat koulusta.
On tärkeää löytää se, mikä toimii sinulle parhaiten ja auttaa sinua oppimaan ja kasvamaan joka päivä.
On hienoa, että on olemassa erilaisia tapoja oppia, joten jokainen voi löytää itselleen parhaiten sopivan.`;

export default online_learing;